/// <reference types="@angular/localize" />


import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from 'src/app/app.config';

import { environment } from './environments/environment';

import { AppComponent } from './app/app.component';
import { RouteReuseStrategy } from '@angular/router';

import { RouteReuseStrategyService } from './app/services/route-reuse-strategy.service';


if (environment.production) {
  enableProdMode();
}

bootstrapApplication(
  AppComponent,
  {
    ...appConfig,
    providers: [
      provideZoneChangeDetection(),
      ...appConfig.providers,
      { provide: RouteReuseStrategy, useClass: RouteReuseStrategyService }
    ]
  }
).catch(err => console.error(err));
